// extracted by mini-css-extract-plugin
export default {"video":"D27y1epOQG","videoBackground":"SceJP0MODT","checkbox":"ixP5O0h9WY"};